import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Checkbox } from 'ui-components/components/checkbox';

import { LabelQueuePrintDocumentButton } from '../../../../containers/print-document-button-containers/label-que';
import Global from '../../../../store/global-selectors';
import {
  selectAllLabelQueBatches,
  deSelectAllLabelQueBatches,
  labelQueArchiveBatches,
} from '../../../../store/label-que/label-que.actions';

import style from './style.module.less';

const LabelQueHeader = () => {
  const dispatch = useDispatch();
  const batches = useSelector(Global.selectLabelQueBatches);
  const selectedBatchIds = useSelector(Global.selectLabelQueSelectedBatches);

  const areAnySelected = selectedBatchIds.length > 0;
  const areAllSelected = selectedBatchIds.length === batches.length && batches.length > 0;

  const onSelectAll = useCallback(() => {
    dispatch(selectAllLabelQueBatches());
  }, [dispatch]);

  const onDeselectAll = useCallback(() => {
    dispatch(deSelectAllLabelQueBatches());
  }, [dispatch]);

  const onArchiveBatches = useCallback(() => {
    dispatch(labelQueArchiveBatches(selectedBatchIds));
  }, [dispatch, selectedBatchIds]);

  const checkHandler = areAllSelected ? onDeselectAll : onSelectAll;
  return (
    <div className={style['que-actions']}>
      <div className={style.buttons}>
        <Checkbox checked={areAllSelected} onChange={checkHandler} />
        <LabelQueuePrintDocumentButton disabled={!areAnySelected} />
        <Button className={style['archive-button']} disabled={!areAnySelected} onClick={onArchiveBatches} theme='tertiary'>
          <FormattedMessage defaultMessage='Archive' description='labelQueActions.archive' id='fD211g' />
        </Button>
      </div>
    </div>
  );
};

export default LabelQueHeader;
